export default {
  data() {
    return {
      valid: true
    };
  },
  methods: {
    moveListItem(dir, idi, list) {
      // define inded and list
      let newList = [];
      let oldList = list;
      let newIndex = 0;
      let oldIndex = 0;
      // [1] identify which idnex corresponds to idi
      for (let i = 0; i < oldList.length; i++) {
        if (oldList[i].basic.idi === idi) {
          oldIndex = i;
        }
      }
      // [2] set new index
      if (dir === "up" && oldIndex !== 0) {
        newIndex = oldIndex - 1;
      } else if (dir === "down" && oldIndex !== oldList.length - 1) {
        newIndex = oldIndex + 1;
      } else {
        newIndex = oldIndex;
      }
      // [3] Create New list
      for (let i = 0; i < oldList.length; i++) {
        if (i === newIndex) {
          newList.push(oldList[oldIndex]);
        } else if (i === oldIndex) {
          newList.push(oldList[newIndex]);
        } else {
          newList.push(oldList[i]);
        }
      }
      // [4] retuen
      console.log(newList);
      return newList;
    }
  }
};
